import { useSnackbar } from "notistack";

// Excel em português separa colunas por ";" (a vírgula é o decimal): com "," o arquivo abria numa coluna só
export const SEPARADOR_CSV = ';';

// Número com casa decimal sai com vírgula, senão o Excel em português lê "1.5" como data
function textoDaCelula(value) {
    if (typeof value === 'number' && !Number.isInteger(value)) {
        return String(value).replace('.', ',');
    }
    return String(value);
}

/**
 * Converte um array de objetos (JSON) em uma string CSV, com base em opções de formatação.
 * @param {Array<Object>} data O array de dados.
 * @param {Object} options Opções para customizar a saída (colunas, cabeçalhos, formatadores).
 * @returns {string} Uma string formatada como CSV.
 */
export function convertToCSV(data, options = {}) {
    if (!data || data.length === 0) {
        return '';
    }

    const {
        columns = Object.keys(data[0]),
        headers: headerMap = {},
        formatters = {},
        defaultValue = 'N/D'
    } = options;

    const csvHeaders = columns.map(key => headerMap[key] || key).join(SEPARADOR_CSV);
    const csvRows = [csvHeaders];

    for (const row of data) {
        const values = columns.map(key => {
            let value = row[key];

            if (formatters[key]) {
                value = formatters[key](value);
            } else if (value === null || value === undefined || value === '') {
                value = defaultValue;
            }

            const escaped = textoDaCelula(value).replace(/"/g, '""');
            return `"${escaped}"`;
        });
        csvRows.push(values.join(SEPARADOR_CSV));
    }

    return csvRows.join('\n');
}

export function useExport() {
    const { enqueueSnackbar } = useSnackbar();

    /**
     * Função genérica para iniciar o download de um relatório CSV.
     * @param {Array<Object>} data O array de dados a ser exportado.
     * @param {Object} options As opções de formatação (colunas, cabeçalhos, formatadores).
     * @param {string} filename O nome base para o arquivo.
     */
    function handleExport(data, options = {}, filename = 'relatorio') {
        if (!data || data.length === 0) {
            enqueueSnackbar("Não há dados para exportar.", { variant: 'warning' });
            return;
        }

        try {
            const csvString = convertToCSV(data, options);
            if (!csvString) {
                enqueueSnackbar("Os dados não puderam ser processados.", { variant: 'error' });
                return;
            }

            const blob = new Blob([`\uFEFF${csvString}`], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            const safeFilename = filename.replace(/[^a-z0-9]/gi, '_').replace(/_+/g, '_');
            link.setAttribute('href', url);
            link.setAttribute('download', `${safeFilename}-relatorio.csv`.toLowerCase());
            link.style.visibility = 'hidden';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            enqueueSnackbar("Download do relatório iniciado!", { variant: 'success' });

        } catch (error) {
            console.error("Erro ao exportar para CSV:", error);
            enqueueSnackbar("Ocorreu um erro ao gerar o relatório.", { variant: 'error' });
        }
    }

    return { handleExport };
}